import React, { useState } from 'react';
import StrainDetails from './StrainDetails';

const SearchForm = () => {
  const [strains, setStrains] = useState([]);
  const [selectedStrain, setSelectedStrain] = useState(null);
  const [details, setDetails] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const fetchStrains = async (query) => {
    const apiUrl = `https://en.seedfinder.eu/api/json/search.json?ac=30eb9835d49baf6e460bcf940282125f&output=0&parents=1&q=${encodeURIComponent(query)}`;
    const response = await fetch(apiUrl);
    const data = await response.json();
    document.getElementById('response').innerHTML = "Found " + data.count + " genetic variations!";
    setStrains(data.strains);
  };

  const fetchStrainDetails = async (strainId, strainBrid) => {
    const strainDetailUrl = `https://de.seedfinder.eu/api/json/strain.json?ac=30eb9835d49baf6e460bcf940282125f&output=0&br=${strainBrid}&str=${strainId}&parents=1`;
    const response = await fetch(strainDetailUrl);
    const data = await response.json();
    setDetails(data);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchStrains(searchQuery);
  };

  const handleStrainChange = (e) => {
    const selectedValues = e.target.value.split('-o-');
    setSelectedStrain({ id: selectedValues[0], brid: selectedValues[1] });
  };

  return (
    <div>
      <div className="form-container">
        <div className="App-body">
          <div className="otto">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="searchBox">Enter STRAIN to search:</label>
                <input type="text" id="searchBox" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} required />
                <button type="submit">Search</button>
              </div>
            </form>
            <div className="form-group">

             <div id="response" className="search-response"></div>
              <label htmlFor="strainsDropdown">Select a Strain:</label>
              <select id="strainsDropdown" onChange={handleStrainChange}>
                <option value="">--Select a Strain--</option>
                {strains && Object.entries(strains).map(([strainName, strainData]) => (
                  <option key={strainData.id} value={`${strainData.id}-o-${strainData.brid}`}>
                    {strainData.id} by  {strainData.brid}
                  </option>
                ))}
              </select>
            </div>
            {selectedStrain && <StrainDetails strain={selectedStrain} fetchStrainDetails={fetchStrainDetails} details={details} />}
          </div>
        </div>
      </div>
    </div>
  );
};

// Assume StrainDetails is defined elsewhere and properly imported.

export default SearchForm;
